/* eslint-disable */
import utils from '../../../../utils/utils.js';
import { serialize, parse, ensurePanelDetail, DASHBOARD_TYPE_TO_KEY, pageKeyFor } from '../shared/helpers.js';

// Allowed dashboard types: 12 operational, 13 brand, 14 mt
const ALLOWED_TYPES = new Set([12, 13, 14]);
function isAllowedType(t){
  if (t === undefined || t === null) return false;
  return ALLOWED_TYPES.has(Number(t));
}

// pageKeyFor artık helpers.js'den geliyor

// Tipi güvenli şekilde sayıya çevir (resolveType kullanmadan, try/catch olmadan)
const coerceType = (t) => {
  if (t === undefined || t === null) return undefined;
  const n = Number(t);
  if (isAllowedType(n)) return n;
  const s = String(t).toLowerCase();
  if (s === 'operational' || s === 'operation' || s === 'op') return 12;
  if (s === 'brand') return 13;
  if (s === 'mt') return 14;
  return undefined;
};

// Güvenli fetch: Sniffdeck pattern - utils.utility.fetch already handles errors
const fetchSafe = (url, method, headers, body, auth) =>
  utils.utility.fetch(url, method, headers, body, auth);

// Global request state for preventing duplicates
const globalDashboardRequestState = {
  activeRequests: new Set(),
  lastRequestTime: new Map()
};

// Objeden olası id yakala (hatasız)
const pickId = (obj) => {
  if (!obj || typeof obj !== 'object') return null;
  const candidates = [
    'id','Id','ID',
    'dashboardId','DashboardId','DashboardID',
    'panelId','PanelId','PanelID',
    'userDashboardId','UserDashboardId',
    'userDashboardSettingId','UserDashboardSettingId'
  ];
  for (const k of candidates) {
    const v = obj[k];
    if (v !== undefined && v !== null && Number(v) > 0) return Number(v);
  }
  if (obj.result) {
    const v = pickId(obj.result); if (v) return v;
  }
  if (obj.data) {
    const v = pickId(obj.data); if (v) return v;
  }
  if (obj.payload) {
    const v = pickId(obj.payload); if (v) return v;
  }
  return null;
};

const actions = {
  // ---------------------------------------------------------------------------
  // PERSIST: backend-only panel creation + refresh
  // ---------------------------------------------------------------------------
  async createServerPanel({ dispatch }, { dashboardType, date }) {
    // Workspace context (WorkspaceId header)
  await Promise.resolve(dispatch('user/checkClientContext', null, { root: true })).catch(() => undefined);
    const numericType = coerceType(dashboardType);
    if (!isAllowedType(numericType)) {
      return { success:false, error:'dashboardType not allowed' };
    }
    const nowStr = new Date().toISOString();
    const title  = `Panel ${nowStr.slice(0,10)}`;
    let createdId = null;

  // Single call to dedicated create endpoint
  const confObj = { version: 1, structure: '1', widgets: [] };
  const configuration = JSON.stringify(confObj);
  const body = { title, name: title, configuration, ...(date ? { date } : {}), dashboardType: numericType };
  
  const createResp = await fetchSafe('api/dashboard/CreateUserDashboard','POST',null,body,true);
  
  const rootCreate = createResp?.data || createResp?.payload || createResp || {};
  
  createdId = createResp?.id || createResp?.Id || createResp?.dashboardId || createResp?.userDashboardId ||
              createResp?.data?.id || createResp?.data?.Id || createResp?.data?.dashboardId ||
              createResp?.result?.id || createResp?.result?.Id ||
              pickId(rootCreate) || pickId(createResp) || null;
              
  
  

  if (!createdId) return { success:false, error: 'Panel oluşturulamadı' };
  // Sadece oluştur ve id döndür; liste GET'i çağıran taraf karar verir
  return { success: true, id: createdId };
  },
  // ---------------------------------------------------------------------------
  // PERSIST: dashboard detail save / delete
  async saveUserDashboardSettingDetail({ state, commit, dispatch }, { dashboardType, panelId, pageType }){
    if (!panelId) return { success:false, error:'panelId gerekli' };
    
    const numericTypeForGuard = coerceType(dashboardType || pageType);
    if (!isAllowedType(numericTypeForGuard)) {
      return { success:false, error:'dashboardType not allowed' };
    }

    // Ensure workspace context
    await Promise.resolve(dispatch('user/checkClientContext', null, { root: true })).catch(() => undefined);
    
    commit('SET_LOADING', { type:'saving', status:true });
    commit('SET_ERROR', { type:'save', error:null });

    // Prepare configuration from current detail
    let detail = state.panelDetails?.[panelId];
    if (!detail) detail = ensurePanelDetail(state, panelId, pageType);
    
    const confObj = serialize(detail, panelId);
    if (!confObj) {
      commit('SET_LOADING', { type:'saving', status:false });
      return { success:false, error:'serialize' };
    }

    const body = { id: panelId, dashboardId: panelId, configuration: JSON.stringify(confObj) };
    
    // Sniffdeck pattern: Simple API call, error handling in utils
    const response = await utils.utility.fetch('api/dashboard/UpdateUserDashboard', 'PUT', null, body, true);
    
    // Update cached raw
    if (state.panelDetails?.[panelId]) {
      const upd = { ...state.panelDetails[panelId] };
      if (upd.raw) {
        upd.raw.configuration = body.configuration;
        if (response.version || response.Version) upd.raw.version = response.version || response.Version;
      }
      commit('COMMIT_PANEL_DETAIL',{ panelId, detail: upd });
    }
    
    commit('SET_LOADING', { type:'saving', status:false });
    return { success:true, data: response };
  },

  // Lightweight wrapper to refresh panels for a pageType
  async loadPanels({ dispatch }, { pageType, date, panelId, withDetail = true }) {
    const numericType = coerceType(pageType);
    if (!isAllowedType(numericType)) {
      return { success:true, panels:[], activePanelId:null };
    }
  await Promise.resolve(dispatch('user/checkClientContext', null, { root: true })).catch(() => undefined);
    const res = await dispatch('loadUserDashboardSetting', { dashboardType: pageType, date, panelId, withDetail });
    return res;
  },

  // Save-only layout update using currently active panel for the pageType
  async saveDashboardLayout({ state, commit, dispatch }, { pageType, layout }) {
    const pageKey = pageKeyFor(pageType);
    const panelId = state.activePanel?.[pageKey] || state.activePanelIds?.[pageKey];
    if (!panelId) return { success: false, error: 'active panel yok' };
    let detail = state.panelDetails[panelId];
    if (!detail) {
      detail = ensurePanelDetail(state, panelId, pageKey);
    }
    detail = { ...detail, layout };
    commit('COMMIT_PANEL_DETAIL', { panelId, detail });
    commit('SET_DASHBOARD_LAYOUT', { pageType: pageKey, layout });
    const res = await dispatch('saveUserDashboardSettingDetail', { dashboardType: pageType, panelId, pageType: pageKey });
    return res;
  },

  async deleteUserDashboardSettingDetail({ state, commit }, { panelId }){
    if (!panelId) return { success:false, error:'panelId gerekli' };
    const finish = (res) => { commit('SET_LOADING',{ type:'saving', status:false }); return res; };
    commit('SET_LOADING', { type:'saving', status:true });
    commit('SET_ERROR', { type:'save', error:null });
    const body = { id: panelId, dashboardId: panelId, configuration: JSON.stringify({}) };
    const resp = await fetchSafe('api/dashboard/UpdateUserDashboard','PUT',null,body,true);
    const root = resp?.data || resp?.payload || resp || {};
    if (!resp || (root?.statusCode && ![200,201].includes(root.statusCode))) {
      commit('SET_ERROR',{ type:'save', error: root?.message||'Silme başarısız' });
      return finish({ success:false, error: root?.message });
    }
    if (state.panelDetails && state.panelDetails[panelId]) { delete state.panelDetails[panelId]; }
    if (state.panels) {
      Object.keys(state.panels).forEach(pt => {
        const list = state.panels[pt];
        if (Array.isArray(list) && list.find(p=>p.id===panelId)) {
          commit('REMOVE_PANEL',{ pageType:pt, panelId });
        }
      });
    }
    return finish({ success:true, data: root });
  },

  // ---------------------------------------------------------------------------
  // LAYOUT: panel layout güncelle + persist
  // ---------------------------------------------------------------------------
  async updatePanelLayoutAndPersist({ state, commit, dispatch }, { dashboardType, panelId, pageType, newLayout }) {
    if (!panelId)   return { success:false, error:'panelId gerekli' };
    if (!newLayout) return { success:false, error:'newLayout gerekli' };

    let detail = state.panelDetails[panelId];
    if (!detail) {
      const widgets = (pageType && state.pageWidgets?.[pageType]) ? state.pageWidgets[pageType] : [];
      detail = { layout: newLayout, widgets, raw:{} };
    } else {
      detail = { ...detail, layout: newLayout };
    }
    commit('COMMIT_PANEL_DETAIL', { panelId, detail });
    if (pageType) commit('SET_DASHBOARD_LAYOUT', { pageType, layout: newLayout });

    const res = await dispatch('saveUserDashboardSettingDetail', { dashboardType, panelId, pageType });
    return res;
  },

  // ---------------------------------------------------------------------------
  // WIDGETS: ekle / sil (slot boş kalsın) / update
  // ---------------------------------------------------------------------------
  async addWidgetToPanel({ state, commit, dispatch }, { dashboardType, panelId, pageType, widgetConfig, targetSlotIndex }){
    if (!panelId) return { success:false, error:'panelId gerekli' };
    if (!widgetConfig?.type) return { success:false, error:'widgetConfig/type gerekli' };

  const pageKey = pageKeyFor(pageType);
  const detail = ensurePanelDetail(state, panelId, pageKey);

    if (!Array.isArray(detail.layout?.rows) || !detail.layout.rows.length) {
  detail.layout = { structure:'1', rows:[ { columns:[ { widgetIds:[] } ] } ], version:1 };
    }
    // Layout kolon sayısını belirle (max 3)
    const cols = Math.max(1, Math.min(3, (detail.layout.cols) || (detail.layout.rows[0]?.columns?.length || 1)));
    // Hedef slotIndex verildiyse row-major -> (row,col,idx) hesapla; gerekirse kolon/slotları genişlet
    let useColIndex = 0, useIndexInCol = 0;
    if (Number.isInteger(targetSlotIndex) && targetSlotIndex >= 0) {
      const cIdx = targetSlotIndex % cols;
      const rIdx = Math.floor(targetSlotIndex / cols);
      // Kolonları hazırla
  const columns = detail.layout.rows[0].columns || (detail.layout.rows[0].columns = Array.from({ length: cols }).map(() => ({ widgetIds: [] })));
  while (columns.length < cols) columns.push({ widgetIds: [] });
  const colRef = columns[cIdx] || (columns[cIdx] = { widgetIds: [] });
      if (!Array.isArray(colRef.widgetIds)) colRef.widgetIds = [];
      // Bu slotun sütun içi index'i rIdx
      useColIndex = cIdx;
      useIndexInCol = rIdx;
      // Eğer o index mevcut değilse undefined/null ile doldur
      while (colRef.widgetIds.length < useIndexInCol) colRef.widgetIds.push(null);
      if (colRef.widgetIds.length === useIndexInCol) colRef.widgetIds.push(null); // hedef slot oluşsun
    } else {
      // Hedef verilmediyse ilk sütunun ilk boş slotu
  const columns = detail.layout.rows[0].columns || (detail.layout.rows[0].columns = [ { widgetIds:[] } ]);
      const firstCol = columns[0];
      if (!Array.isArray(firstCol.widgetIds)) firstCol.widgetIds = [];
      const emptyIndex = firstCol.widgetIds.indexOf(null);
      useColIndex = 0;
      useIndexInCol = emptyIndex > -1 ? emptyIndex : firstCol.widgetIds.length;
      if (emptyIndex === -1) firstCol.widgetIds.push(null);
    }

    const columnsFinal = detail.layout.rows[0].columns;
    const targetCol = columnsFinal[useColIndex];
    if (!Array.isArray(targetCol.widgetIds)) targetCol.widgetIds = [];

    const existing = Array.isArray(detail.widgets) ? [...detail.widgets] : [];

    const newId = `local_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    const newWidget = {
      id: newId,
      type: widgetConfig.type,
      title: widgetConfig.title || widgetConfig.type,
      // Two-title pattern persisted
      widgetTitle: widgetConfig.widgetTitle || widgetConfig.title || widgetConfig.type,
      chartTitle: widgetConfig.chartTitle || widgetConfig.title || widgetConfig.type,
      position: (useIndexInCol * cols) + useColIndex,
      slotIndex: (useIndexInCol * cols) + useColIndex,
      row: 0, col: 0,
      orderInColumn: useIndexInCol,
      dashboardId: panelId,
      // Widget metadata'lar (config değil)
      ...(widgetConfig.widgetId && { widgetId: widgetConfig.widgetId }),
      ...(widgetConfig.endpoint && { endpoint: widgetConfig.endpoint }),
      ...(widgetConfig.param && { param: widgetConfig.param }),
      ...(widgetConfig.chartType && { chartType: widgetConfig.chartType }),
      ...(widgetConfig.icon && { icon: widgetConfig.icon }),
      ...(widgetConfig.component && { component: widgetConfig.component }),
      ...(widgetConfig.dialogType && { dialogType: widgetConfig.dialogType }),
      ...(widgetConfig.settingsDialog !== undefined && { settingsDialog: widgetConfig.settingsDialog }),
      ...(widgetConfig.widgetType && { widgetType: widgetConfig.widgetType }),
      ...(widgetConfig.dashboardType && { dashboardType: widgetConfig.dashboardType }),
      ...(widgetConfig.paramStrategy && { paramStrategy: widgetConfig.paramStrategy }),
      ...(widgetConfig.description && { description: widgetConfig.description }),
      // Config sadece kullanıcı ayarları için
      config: widgetConfig.config || {},
      data: { _temp:true }
    };

    existing.push(newWidget);
    targetCol.widgetIds[useIndexInCol] = newId;

    commit('COMMIT_PANEL_DETAIL',{ panelId, detail:{ ...detail, widgets: existing } });
    if (pageKey) commit('SET_PAGE_WIDGETS',{ pageType: pageKey, widgets: existing });

  // Persist layout + widgets
  const saveRes = await dispatch('saveUserDashboardSettingDetail',{ dashboardType, panelId, pageType: pageKey });
    return { success: saveRes.success, data:newWidget, save: saveRes };
  },

  // SLOT BOŞ KALSIN: splice yok, position normalize yok
  async removeWidgetFromPanel({ state, commit, dispatch }, { dashboardType, panelId, pageType, widgetId }){
    if (!panelId)  return { success:false, error:'panelId gerekli' };
    if (!widgetId) return { success:false, error:'widgetId gerekli' };

    const pageKey = pageKeyFor(pageType);
    const detail = state.panelDetails[panelId];
    if (!detail) return { success:false, error:'detay yok' };

    const prev = Array.isArray(detail.widgets) ? detail.widgets : [];
    const remaining = prev.filter(w=>w.id!==widgetId);
    if (remaining.length === prev.length) return { success:false, error:'widget bulunamadı' };

    // layout.widgetIds içinde id’yi bul → NULL ile yer tut
    (detail.layout?.rows||[]).forEach(r =>
      (r.columns||[]).forEach(c => {
        if (!Array.isArray(c.widgetIds)) return;
        const i = c.widgetIds.indexOf(widgetId);
        if (i > -1) c.widgetIds[i] = null; // 👈 boş slot
      })
    );

  // position’ları SIKLAŞTIRMA (slot yerinde kalsın) — grid stabil kalsın
    // remaining.forEach((w,i)=>{ w.position=i; }); // ❌ KALDIRILDI

    commit('COMMIT_PANEL_DETAIL',{ panelId, detail:{ ...detail, widgets: remaining } });
  if (pageKey) commit('SET_PAGE_WIDGETS',{ pageType: pageKey, widgets: remaining });

  const saveRes = await dispatch('saveUserDashboardSettingDetail',{ dashboardType, panelId, pageType: pageKey });
    return { success: saveRes.success, removed: widgetId, save: saveRes };
  },

  

  // ---------------------------------------------------------------------------
  // PANELS + DETAIL LOAD
  // ---------------------------------------------------------------------------
  // Reorder widgets by new array, update positions and layout.widgetIds accordingly, then persist
  async reorderWidgets({ state, commit, dispatch }, { dashboardType, panelId, pageType, widgets }){
    if (!panelId) return { success:false, error:'panelId gerekli' };
    const pageKey = pageKeyFor(pageType);
    let detail = state.panelDetails[panelId];
    if (!detail) {
      detail = ensurePanelDetail(state, panelId, pageKey);
      commit('COMMIT_PANEL_DETAIL', { panelId, detail });
    }
    const incoming = Array.isArray(widgets) ? widgets.filter(w=>w && w.id) : [];
    const currentLayout = pageKey ? (state.dashboardLayouts?.[pageKey] || detail.layout || {}) : (detail.layout||{});
    let cols = (Array.isArray(currentLayout.rows) && currentLayout.rows[0]?.columns?.length) || currentLayout.cols || Number(currentLayout.structure) || 1;
    cols = Math.max(1, Math.min(3, Number(cols) || 1));
    const columns = Array.from({ length: cols }).map(() => ({ widgetIds: [] }));
    const nextWidgets = (detail.widgets||[]).map(w => {
      const found = incoming.find(x=>x.id===w.id);
      if (found && Number.isFinite(Number(found.slotIndex))) {
        const desired = Number(found.slotIndex);
        return { ...w, position: desired, slotIndex: desired, config: { ...(w.config||{}) } };
      }
      return w;
    });
    nextWidgets
      .filter(w=>Number.isFinite(Number(w.slotIndex)))
      .sort((a,b)=>a.slotIndex-b.slotIndex)
      .forEach(w => {
        const idx = Number(w.slotIndex);
        const cI = idx % cols;
        const rI = Math.floor(idx / cols);
        const colRef = columns[cI];
        while (colRef.widgetIds.length < rI) colRef.widgetIds.push(null);
        if (colRef.widgetIds.length === rI) colRef.widgetIds.push(null);
        colRef.widgetIds[rI] = w.id;
      });
    const layout = { ...(detail.layout||{}), cols, structure: String(cols), rows: [ { columns } ] };
    const newDetail = { ...detail, widgets: nextWidgets, layout };
    commit('COMMIT_PANEL_DETAIL', { panelId, detail: newDetail });
    if (pageKey) {
      commit('SET_PAGE_WIDGETS', { pageType: pageKey, widgets: nextWidgets });
      commit('SET_DASHBOARD_LAYOUT', { pageType: pageKey, layout });
    }
    const saveRes = await dispatch('saveUserDashboardSettingDetail', { dashboardType, panelId, pageType: pageKey });
    return { success: saveRes.success, save: saveRes };
  },
  async createPanel({ state, commit, dispatch }, { pageType, panel }){
    const pageKey = pageKeyFor(pageType);
    
    // Önce mevcut panel listesini al (karşılaştırma için)
    const currentPanels = (state.panels && state.panels[pageKey]) ? state.panels[pageKey] : [];
    const currentIds = currentPanels.map(p => p.id);
    
    const createRes = await dispatch('createServerPanel', { dashboardType: pageType, date: panel?.date });
    let pid = createRes.id || createRes.activePanelId || (Array.isArray(createRes.panels) ? createRes.panels[createRes.panels.length - 1]?.id : null);
    
    
    // Eğer backend'den id alınamazsa, liste yükleyip yeni paneli bul
    if (!pid) {
      await Promise.resolve(
        dispatch('loadUserDashboardSetting', { dashboardType: pageType, date: panel?.date, withDetail: false })
      ).catch(() => undefined);
      
      const newPanels = (state.panels && state.panels[pageKey]) ? state.panels[pageKey] : [];
      const newIds = newPanels.map(p => p.id);
      
      // Yeni eklenen panel id'sini bul (mevcut listede olmayan)
      const addedIds = newIds.filter(id => !currentIds.includes(id));
      
      if (addedIds.length > 0) {
        // En büyük id'yi al (en son eklenen olma ihtimali yüksek)
        pid = Math.max(...addedIds);
      }
    }
    
    if (pid) {
      commit('SET_ACTIVE_PANEL', { pageType: pageKey, panelId: pid });
      
      if (createRes.id) {
        await Promise.resolve(
          dispatch('loadUserDashboardSetting', { dashboardType: pageType, panelId: pid, date: panel?.date, withDetail: false })
        ).catch(() => undefined);
      }
    }
    
    if (!createRes?.success) return { success:false, error: createRes?.error || 'Panel oluşturulamadı' };
    return { success:true, panelId: pid, data: createRes };
  },

  async setActivePanel({ commit, dispatch }, { pageType, panelId, dashboardType }){
    const pageKey = pageKeyFor(pageType);
    commit('SET_ACTIVE_PANEL',{ pageType: pageKey, panelId });
    // Panel değişti → detay fetch (cache atla)
    const dt = dashboardType ?? pageType;
    if (panelId) {
  await dispatch('loadUserDashboardSettingDetail', { dashboardType: dt, panelId, pageType: pageKey, useCache:false });
    }
  },

  // Panel listesi + aktif panel + (opsiyonel) ilk detay
  async loadUserDashboardSetting({ commit, state, dispatch }, { dashboardType, panelId, date, withDetail = true }) {
    // Duplicate request prevention
    const requestKey = JSON.stringify({ dashboardType, panelId, date, withDetail });
    const now = Date.now();
    
    if (globalDashboardRequestState.activeRequests.has(requestKey)) {
      return { success: true, skipped: true, reason: 'duplicate request' };
    }
    
    const lastTime = globalDashboardRequestState.lastRequestTime.get(requestKey);
    if (lastTime && (now - lastTime) < 1000) {
      return { success: true, skipped: true, reason: 'too soon' };
    }
    
    globalDashboardRequestState.activeRequests.add(requestKey);
    globalDashboardRequestState.lastRequestTime.set(requestKey, now);
    
    commit('SET_LOADING', { type: 'layouts', status: true });
    commit('SET_LOADING', { type: 'widgets', status: true });
    commit('SET_ERROR', { type: 'layout',  error: null });
    commit('SET_ERROR', { type: 'widgets', error: null });

    const finish = (res) => {
      commit('SET_LOADING', { type: 'layouts', status: false });
      commit('SET_LOADING', { type: 'widgets', status: false });
      globalDashboardRequestState.activeRequests.delete(requestKey);
      return res;
    };

    const numericType = coerceType(dashboardType);
    if (!isAllowedType(numericType)) {
      return finish({ success:true, layout:null, widgets:[], panels:[], activePanelId:null });
    }
  await Promise.resolve(dispatch('user/checkClientContext', null, { root: true })).catch(() => undefined);

    const paramsObj = { dashboardType: numericType };
    if (panelId) paramsObj.panelId = panelId;
    const params = utils.utility.checkQueryParams(paramsObj);
    const responseData = await fetchSafe(`api/dashboard/GetUserDashboardSetting?${params.toString()}`, 'GET', null, null, true);
    if (!responseData) {
      const msg = 'Liste yüklenemedi';
      commit('SET_ERROR', { type: 'layout',  error: msg });
      commit('SET_ERROR', { type: 'widgets', error: msg });
      return finish({ success: false, error: msg });
    }

    const root = responseData?.data || responseData?.payload || responseData || {};
    const rawOptions = Array.isArray(root.userDashboardOptionList) ? root.userDashboardOptionList : [];
    
    const layout    = root.layout || root.dashboardLayout || null;
    const widgets   = Array.isArray(root.widgets) ? root.widgets : (Array.isArray(root.pageWidgets) ? root.pageWidgets : []);
    const available = Array.isArray(root.availableWidgets) ? root.availableWidgets : [];
    let panels      = Array.isArray(root.panels) ? root.panels : [];

    if (!panels.length && rawOptions.length) {
      const todayStr = date || new Date().toISOString().slice(0,10);
      
      panels = rawOptions.map(o => {
        let panelName = `Panel ${o.id}`;
        
        // Configuration'dan panelName'i çıkarmaya çalış
        if (o.configuration) {
          const config = JSON.parse(o.configuration);
          
          if (config.panelName && config.panelName.trim()) {
            panelName = config.panelName;
          }
        }
        
        return {
          id: o.id,
          name: panelName,
          isDefault: !!o.isDefault,
          date: todayStr,
          config: {},
          // rawOptions'daki tüm veriyi de saklayalım, ihtiyaç olursa
          _raw: o
        };
      });
    }

    // Prefer explicitly requested panelId (user selection) over backend defaults
    let activePanelId = panelId || root.activePanelId || root.panelId || null;
    if (!activePanelId) {
      const def = panels.find(p => p.isDefault);
      activePanelId = def?.id || panels[0]?.id || null;
    }    const pageTypeKey = (typeof dashboardType === 'string' && dashboardType) || DASHBOARD_TYPE_TO_KEY[numericType] || root.pageType || 'operational';

    if (activePanelId && !panels.find(p => p.id === activePanelId)) {
      // Yeni panel için de aynı mantığı uygula
      let panelName = `Panel ${activePanelId}`;
      
      // Eğer detail data varsa configuration'dan name'i almaya çalış
      if (root.configuration) {
        const config = JSON.parse(root.configuration);
        if (config.panelName && config.panelName.trim()) {
          panelName = config.panelName;
        }
      }
      
      panels.push({ 
        id: activePanelId, 
        name: panelName, 
        date: date || new Date().toISOString().slice(0,10), 
        config: {} 
      });
    }

    const enrichedPanels = panels.map(p => p.id === activePanelId ? { ...p, layoutRef: layout ? 'loaded' : null } : p);

    // Panel listesini set et
  if (layout)   commit('SET_DASHBOARD_LAYOUT', { pageType: pageTypeKey, layout });
  if (widgets)  commit('SET_PAGE_WIDGETS',     { pageType: pageTypeKey, widgets });
    if (available.length) commit('SET_AVAILABLE_WIDGETS', { pageType: pageTypeKey, widgets: available });
    if (enrichedPanels.length) commit('SET_PANELS', { pageType: pageTypeKey, panels: enrichedPanels });
  if (activePanelId) commit('SET_ACTIVE_PANEL', { pageType: pageTypeKey, panelId: Number(activePanelId) });

    // Eğer rawOptions'da configuration yoksa, paneller için configuration'ları yükle
    if (rawOptions.length > 0 && !rawOptions[0].configuration) {
      // Her panel için configuration yükle (paralel)
      const configPromises = rawOptions.map(async (option) => {
        const base = { dashboardType: coerceType(dashboardType), dashboardId: option.id };
        const detailParams = utils.utility.checkQueryParams(base);
        const qs = detailParams.toString();
        const configResp = await fetchSafe(`api/dashboard/GetUserDashboardSettingDetail?${qs}`, 'GET', null, null, true);
        
        if (configResp?.data?.configuration) {
          const config = JSON.parse(configResp.data.configuration);
          if (config.panelName && config.panelName.trim()) {
            return { id: option.id, name: config.panelName };
          }
        }
        
        return { id: option.id, name: `Panel ${option.id}` };
      });
      
      const panelConfigs = await Promise.all(configPromises);
      
      const updatedPanels = enrichedPanels.map(panel => {
        const configPanel = panelConfigs.find(c => c.id === panel.id);
        return configPanel ? { ...panel, name: configPanel.name } : panel;
      });
      
      commit('SET_PANELS', { pageType: pageTypeKey, panels: updatedPanels });
    }

  let detailData = null;
  if (withDetail && activePanelId) {
      const base = { dashboardType: coerceType(dashboardType), dashboardId: activePanelId };
      const detailParams = utils.utility.checkQueryParams(base);
      const qs = detailParams.toString();
      const detailResp = await fetchSafe(`api/dashboard/GetUserDashboardSettingDetail?${qs}`, 'GET', null, null, true);
      detailData = detailResp?.data || detailResp?.payload || detailResp || null;
      if (detailData?.configuration) {
        const parsed = parse(detailData, activePanelId);
        if (parsed) {
          commit('COMMIT_PANEL_DETAIL', { panelId: activePanelId, detail: parsed });
          if (parsed.layout)  commit('SET_DASHBOARD_LAYOUT', { pageType: pageTypeKey, layout: parsed.layout });
          if (parsed.widgets) commit('SET_PAGE_WIDGETS',     { pageType: pageTypeKey, widgets: parsed.widgets });
        }
      }
    }

    return finish({ success: true, layout, widgets, panels, activePanelId, detail: detailData });
  },

  // Detay endpoint: panel seçildiğinde çağrılacak (cache + parse)
  async loadUserDashboardSettingDetail({ commit, state, dispatch }, { dashboardType, panelId, pageType, useCache=true }) {
    if (!panelId) { return { success:false, error:'panelId required' } }

    // Sadece o sayfadaki AKTİF panel için detay getir; tutarsız id'leri atla
    const pageKey = pageKeyFor(pageType || dashboardType);
    const currentActive = pageKey ? (state.activePanel?.[pageKey] || null) : null;
    if (currentActive && Number(currentActive) !== Number(panelId)) {
      return { success:true, skipped:true, reason:'panel mismatch (not active)' };
    }

    if (useCache && state.panelDetails?.[panelId]) {
      const cached = state.panelDetails[panelId];
      if (pageType){
        commit('SET_DASHBOARD_LAYOUT', { pageType, layout: cached.layout });
        commit('SET_PAGE_WIDGETS',     { pageType, widgets: cached.widgets });
      }
      return { success:true, data: cached.raw, cached:true };
    }
    const numericType = coerceType(dashboardType);
    if (!isAllowedType(numericType)) { return { success:true, data:null } }
  await Promise.resolve(dispatch('user/checkClientContext', null, { root: true })).catch(() => undefined);
    const paramsObj = { dashboardType: numericType, dashboardId: panelId };
    const params = utils.utility.checkQueryParams(paramsObj);
    const qs = params.toString();
    const responseData = await fetchSafe(`api/dashboard/GetUserDashboardSettingDetail?${qs}`,'GET',null,null,true);
    const root = responseData?.data || responseData?.payload || responseData || {};
    if (root?.configuration) {
      const parsed = parse(root, panelId);
      if (parsed){
        commit('COMMIT_PANEL_DETAIL', { panelId, detail: parsed });
        if (pageType){
          commit('SET_DASHBOARD_LAYOUT', { pageType, layout: parsed.layout });
          commit('SET_PAGE_WIDGETS',     { pageType, widgets: parsed.widgets });
        }
      }
    }
    return { success:true, data: root };
  },

  // Utils
  clearErrors({ commit }) { commit('CLEAR_ERRORS'); },

  // Update widget configuration
  async updateWidgetConfig({ commit, state, dispatch }, { dashboardType, panelId, pageType, widgetId, changes }) {
    try {
      if (!panelId) {
        return { success: false, error: 'panelId is required' };
      }
      
      if (!widgetId) {
        return { success: false, error: 'widgetId is required' };
      }
      
      const detail = state.panelDetails[panelId];
      if (!detail) {
        return { success: false, error: 'Panel detail not found' };
      }
      
      const currentWidgets = detail.widgets || [];
      
      // Widget'ı bul ve güncelle (Two-title kuralı: title değişirse sadece widgetTitle + legacy title değişir)
      const updatedWidgets = currentWidgets.map(widget => {
        if (widget.id === widgetId) {
          const updatedWidget = {
            ...widget,
            ...changes
          };
          
          return updatedWidget;
        }
        return widget;
      });
      
      // Panel detail'ı güncelle
      const updatedDetail = {
        ...detail,
        widgets: updatedWidgets
      };
      
      commit('COMMIT_PANEL_DETAIL', { panelId, detail: updatedDetail });
      
      // PageType widget'larını da güncelle (UI sync için)
      if (pageType) {
        const pageKey = pageKeyFor(pageType);
        commit('SET_PAGE_WIDGETS', { pageType: pageKey, widgets: updatedWidgets });
      }
      
      // Backend'e persist et (serialize artık widgetTitle/chartTitle içerir)
      const saveResult = await dispatch('saveUserDashboardSettingDetail', { 
        dashboardType, 
        panelId, 
        pageType: pageKeyFor(pageType) 
      });
      
      return { success: true, saveResult };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // ============================================================================
  // CROSS-MODULE SHARED FUNCTIONS - Sniffdeck Pattern
  // ============================================================================
  // ============================================================================
  // CROSS-MODULE SHARED FUNCTIONS - Sniffdeck Pattern
  // ============================================================================
  
  // Shared account loading for all dashboard types
  async loadWorkspaceAccounts({ commit }) {
    const response = await utils.utility.fetch(
      'api/dashboard/GetAllWorkspaceActiveAccounts', 
      'GET', null, null, true // Silent mode
    );
    
    commit('SET_ACCOUNTS', response);
    return response;
  },

  // Panel silme - Sniffdeck pattern
  async deletePanel({ commit, dispatch }, { pageType, panelId }) {    
    if (!panelId) return { success: false, error: 'Panel ID gerekli' };



    
    // Panel ID'yi sayıya çevir ve geçerli olup olmadığını kontrol et
    const numericPanelId = Number(panelId);
    if (isNaN(numericPanelId) || numericPanelId <= 0) {
      return { success: false, error: 'Geçersiz Panel ID' };
    }

    // Ensure workspace context
    await Promise.resolve(dispatch('user/checkClientContext', null, { root: true })).catch(() => undefined);
    
    commit('SET_LOADING', { type: 'deleting', status: true });
    commit('SET_ERROR', { type: 'delete', error: null });

    // Backend DeleteUserDashboardCommand sadece id field'ı bekliyor
    const body = { 
      id: numericPanelId
    };
    
    const response = await utils.utility.fetch('api/Dashboard/DeleteUserDashboard', 'POST', null, body, true);
    
    
    commit('SET_LOADING', { type: 'deleting', status: false });
    
    // Response'u kontrol et - 400 hatası da dahil
    const isSuccess = response && !response.error && response.statusCode !== 400 && (!response.statusCode || response.statusCode < 400);
    
    
    if (isSuccess) {
      // Panel listesini yenile
      await dispatch('loadUserDashboardSetting', { 
        dashboardType: coerceType(pageType), 
        withDetail: false 
      });
      
      return { success: true, data: response };
    } else {
      // Hata mesajını response'dan al ve daha spesifik hale getir
      let errorMessage = 'Panel silinemedi';
      if (response?.error?.detail) {
        errorMessage = response.error.detail;
        // Backend'den gelen hata mesajını Türkçe'ye çevir
        if (errorMessage.includes('User dashboard could not found')) {
          errorMessage = 'Silinmek istenen panel bulunamadı. Panel mevcut olmayabilir veya başka bir kullanıcıya ait olabilir.';
        }
      } else if (response?.error?.title) {
        errorMessage = response.error.title;
      } else if (response?.error) {
        errorMessage = response.error;
      } else if (response?.message) {
        errorMessage = response.message;
      } else if (response?.statusCode === 400) {
        errorMessage = 'Panel silinirken hata oluştu. Panel ID geçersiz olabilir.';
      }
      
      return { success: false, error: errorMessage, data: response };
    }
  },
  async updatePanel({ commit, dispatch, state }, { pageType, panelId, updates }) {
    if (!panelId || !updates) return { success: false, error: 'Panel ID ve güncellemeler gerekli' };

    await Promise.resolve(dispatch('user/checkClientContext', null, { root: true })).catch(() => undefined);
    
    commit('SET_LOADING', { type: 'updating', status: true });
    commit('SET_ERROR', { type: 'update', error: null });

    // Mevcut panel configuration'ını al
    let currentConfig = { 
      version: 1, 
      panelId: Number(panelId),
      structure: "1", 
      widgets: []
    };
    
    // Eğer state'te panel detail varsa ondan al
    const panelDetail = state.panelDetails?.[panelId];
    if (panelDetail?.raw?.configuration) {
      const parsed = JSON.parse(panelDetail.raw.configuration);
      currentConfig = { ...currentConfig, ...parsed };
    }
    
    // panelName'i ekle/güncelle
    currentConfig.panelName = updates.name || updates.title || '';
    
    // Panel configuration'ını JSON string olarak gönder
    const body = { 
      id: Number(panelId),
      dashboardId: Number(panelId),
      configuration: JSON.stringify(currentConfig)
    };
    
    const response = await utils.utility.fetch('api/dashboard/UpdateUserDashboard', 'PUT', null, body, true);
    
    
    commit('SET_LOADING', { type: 'updating', status: false });
    
    // Önce store'daki panel listesinde name'i hemen güncelle (immediate feedback)
    const pageKey = pageKeyFor(pageType);
    if (state.panels && state.panels[pageKey]) {
      const panelList = [...state.panels[pageKey]];
      const panelIndex = panelList.findIndex(p => Number(p.id) === Number(panelId));
      if (panelIndex !== -1) {
        panelList[panelIndex] = { 
          ...panelList[panelIndex], 
          name: updates.name || updates.title || '' 
        };
        commit('SET_PANELS', { pageType: pageKey, panels: panelList });
      }
    }
    
    // Aktif panel ID'yi sakla
    const currentActivePanelId = Number(panelId);
    
    await dispatch('loadUserDashboardSetting', { 
      dashboardType: coerceType(pageType), 
      panelId: currentActivePanelId, // Aktif panel'i koru
      withDetail: false 
    });
    
    // Aktif panel'in korunduğundan emin ol
    commit('SET_ACTIVE_PANEL', { pageType: pageKey, panelId: currentActivePanelId });
    
    return { success: true, data: response };
  }

};

export default actions;
